import { render, staticRenderFns } from "./Profiles.vue?vue&type=template&id=4c8127bc&scoped=true&lang=html"
import script from "./Profiles.vue?vue&type=script&lang=js"
export * from "./Profiles.vue?vue&type=script&lang=js"
import style0 from "./Profiles.vue?vue&type=style&index=0&id=4c8127bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8127bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c8127bc')) {
      api.createRecord('4c8127bc', component.options)
    } else {
      api.reload('4c8127bc', component.options)
    }
    module.hot.accept("./Profiles.vue?vue&type=template&id=4c8127bc&scoped=true&lang=html", function () {
      api.rerender('4c8127bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/Profiles.vue"
export default component.exports